import { useGetWireTransferSetupQuery } from '@/features/means-of-payments/api/useGetWireTransferSetupQuery.ts';
import { MeanOfPaymentDescription } from '@/features/means-of-payments/MeanOfPaymentDescription.tsx';
import { Alert, Loader, Typography } from '@arsnovasystems/ars-front-lib';
import { useTranslation } from 'react-i18next';

/**
 * Rendered by the library's `CollectMeanOfPayment` when the "wire transfer"
 * option is selected in the payment switcher. Since ars-front-lib no longer
 * owns the wire-transfer flow, the consumer supplies this element to explain
 * the payment method and, when one already exists, show the bank account the
 * partner should transfer funds to.
 *
 * @returns the wire-transfer information block.
 */
export const WireTransferElement = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetWireTransferSetupQuery();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Alert severity={'info'}>
      <Typography variant={'h4'}>{t('ik.bank.transfer')}</Typography>
      <Typography
        variant={'subtitle2'}
        sx={{ marginTop: 1 }}
      >
        {t('ik.meansOfPayments.funding.subheader')}
      </Typography>

      {data ?
        <>
          <Typography
            variant={'body2'}
            sx={{ marginY: 2 }}
          >
            {t('ik.meansOfPayments.funding.approved.message')}
          </Typography>
          <MeanOfPaymentDescription meanOfPayment={data} />
        </>
      : null}
    </Alert>
  );
};
